import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/expensetype/createaction";
import Expensetypelist from "./expensetypelist";

const Expensetype = () => {
  const { recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [expensetype, setexpensetype] = useState();
  const [mizania_statement_number, setmizania_statement_number] = useState();
  const [mizania_directory_number, setmizania_directory_number] = useState();

  const [error, seterror] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">جۆری خەرجی</h1>
          <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی جۆرەکانی خەرجی</p>
        </div>
      </div>

      {/* Add New Expense Type Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="expense_type"
          >
            جۆری خەرجی
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="expense_type"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={expensetype}
            onChange={(val) => setexpensetype(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="mizania_statement_number"
          >
            رقم الكشف
          </label>
          <input
            className={
              "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="mizania_statement_number"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={mizania_statement_number}
            onChange={(val) => setmizania_statement_number(val.target.value)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="mizania_directory_number"
          >
            رقم الدليل
          </label>
          <input
            className={
              "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="mizania_directory_number"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={mizania_directory_number}
            onChange={(val) => setmizania_directory_number(val.target.value)}
          />
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (expensetype == "" || !expensetype) {
                seterror(true);
                return false;
              }
              createaction(expensetype,mizania_statement_number,mizania_directory_number)(recaller)(setrecaller)(initDispatch)(
                clear
              );
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
      </div>

      {/* Expense Type List Section */}
      <Expensetypelist />
    </div>
  );
};

export default Expensetype;
